"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textPresets = exports.viewPresets = void 0;
const base_ui_theme_colors_1 = require("@unboared/base-ui.theme.colors");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
/**
 * All text will start off looking like this.
 */
const BASE_VIEW = {
    justifyContent: 'center',
    alignItems: 'center',
};
/**
 * All the variations of text styling within the app.
 *
 * You want to customize these to whatever you need in your app.
 */
const viewPresets = function (theme, normalizedSize, active = false) {
    return {
        /**
         * A smaller piece of secondard information.
         */
        primary: Object.assign(Object.assign({}, BASE_VIEW), { backgroundColor: theme.buttonColor }),
        /**
         * A smaller piece of secondard information.
         */
        secondary: Object.assign(Object.assign({}, BASE_VIEW), { backgroundColor: active ? theme.buttonColor : theme.secondaryButtonColor }),
        /**
         * A smaller piece of secondard information.
         */
        discord: Object.assign(Object.assign({}, BASE_VIEW), { backgroundColor: base_ui_theme_colors_1.color.dark_secondary, borderWidth: 3, borderColor: '#7289da' }),
        /**
         * A button without extras.
         */
        link: Object.assign(Object.assign({}, BASE_VIEW), { paddingHorizontal: 0, paddingVertical: 0, alignItems: 'flex-start' }),
    };
};
exports.viewPresets = viewPresets;
const textPresets = function (buttonPreset, theme, normalizedSize) {
    const BASE_TEXT = {
        fontSize: normalizedSize,
        fontFamily: theme.buttonFont,
        color: buttonPreset === 'primary'
            ? theme.color.light
            : theme.secondaryButtonTextColor,
    };
    return {
        small: Object.assign(Object.assign({}, BASE_TEXT), { fontWeight: '400' }),
        medium: Object.assign(Object.assign({}, BASE_TEXT), { fontWeight: '700' }),
        large: Object.assign(Object.assign({}, BASE_TEXT), { fontWeight: '600', fontFamily: 'Montserrat', fontSize: 1.2 * normalizedSize }),
        discord: {
            fontWeight: '400',
        },
        link: Object.assign(Object.assign({}, BASE_TEXT), { paddingHorizontal: 0, paddingVertical: 0, fontWeight: '900' }),
    };
};
exports.textPresets = textPresets;
const defaultPreset = (0, exports.viewPresets)(base_ui_theme_themes_1.unboaredTheme.default, 0);
const defaultTextPreset = (0, exports.textPresets)('primary', base_ui_theme_themes_1.unboaredTheme.default, 0);
//# sourceMappingURL=button.preset.js.map